import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

interface TabItem {
  label: string;
}

interface TabsProps {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  enabledTabs?: string[];
  showPreferenceTab?: boolean; // 👈 New prop
}

const TABS: TabItem[] = [
  { label: "Address" },
  { label: "Contacts" },
  { label: "Preferences" },
];

const StakeHolderTabs: React.FC<TabsProps> = ({
  selectedTab = "Address",
  setSelectedTab,
  enabledTabs = [],
  showPreferenceTab = false, // 👈 Default to false
}) => {
  // Filter tabs based on showPreferenceTab
  const visibleTabs = TABS.filter((tab) => {
    if (tab.label === "Preferences") {
      return showPreferenceTab;
    }
    return true;
  });

  return (
    <Tabs
      activeKey={selectedTab}
      onSelect={(key) => key && setSelectedTab(key)}
      className="mb-3 po-tab tabsection"
    >
      {visibleTabs.map((tab) => {
        const disabled =
          enabledTabs.length > 0 ? !enabledTabs.includes(tab.label) : false;

        return (
          <Tab
            eventKey={tab.label}
            title={tab.label}
            key={tab.label}
            disabled={disabled}
          />
        );
      })}
    </Tabs>
  );
};

export default StakeHolderTabs;
